// src/definitions/types.ts
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["ENCA"] = "en_CA";
  Language2["FRCA"] = "fr_CA";
  Language2["EN"] = "en";
  Language2["FR"] = "fr";
  return Language2;
})(Language || {});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["INFO"] = "INFO";
  LogLevel2["ERROR"] = "ERROR";
  return LogLevel2;
})(LogLevel || {});
var Source = /* @__PURE__ */ ((Source2) => {
  Source2["WEB"] = "WEB";
  Source2["IOS"] = "IOS";
  Source2["ANDROID"] = "ANDROID";
  return Source2;
})(Source || {});
function setLogDetails(config, logDetails) {
  config.logDetails = logDetails;
  return config;
}

export {
  Language,
  LogLevel,
  Source,
  setLogDetails
};
